import { NgModule, APP_INITIALIZER, Optional, SkipSelf } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {
  TokenInterceptor,
  ErrorInterceptor,
  AuthGuardService,
  AuthService,
} from 'auth';
import { AppConfigService } from 'app-config';
import { APP_BASE_HREF } from '@angular/common';
import { environment } from 'src/environments/environment';
// import { NavbarModule } from 'navbar';
// import { FooterModule } from 'footer';
import { from, Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { content } from 'src/assets/content';

// export function initConfig(config: AppConfigService) {
//   return () => config.load();
// }

// const completeAuthentication = (
//   config: AppConfigService,
//   authService: AuthService
// ) => {
//   return async () => {
//     console.log('@completeAuthentication -- start. Awaiting config load...');
//     const settings = await config.load();
//     console.log(
//       '@completeAuthentication -- settings loaded. Initializing...',
//       settings
//     );
//     authService.initialize(settings.auth);
//     if (window.location.href.indexOf('?code=') > -1) {
//       console.log('window contains code. Completing authentication...');
//       await authService.completeAuthentication();
//     }
//   };
// };

const initializeApp = (config: AppConfigService, authService: AuthService) => {
  const loadConfig$: Observable<any> = from(config.load());

  return () =>
    loadConfig$
      .pipe(
        map((settings) => {
          authService.initialize(settings.auth);

          if (window.location.href.indexOf('?code=') > -1) {
            return authService.completeAuthentication();
          }
        })
      )
      .toPromise();
};

@NgModule({
  declarations: [],
  imports: [],
  exports: [],
  providers: [
    AppConfigService,
    AuthGuardService,
    AuthService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: initConfig,
    //   deps: [AppConfigService],
    //   multi: true,
    // },
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: completeAuthentication,
    //   deps: [AppConfigService, AuthService],
    //   multi: true,
    // },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfigService, AuthService],
      multi: true,
    },
    {
      provide: APP_BASE_HREF,
      useValue: window['base-href'],
    },
    {
      provide: 'environment',
      useValue: environment,
    },
    {
      provide: 'content',
      useValue: content,
    },
  ],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule has already been loaded. You should only import Core modules in the AppModule only.'
      );
    }
  }
}
